var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperimentReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_805_1940)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2646 0.636353C13.6214 0.636353 12.2894 1.9684 12.2894 3.61156V5.09916H9.31418V8.07437C9.31418 8.89595 9.98021 9.56197 10.8018 9.56197H22.7026C23.5242 9.56197 24.1902 8.89595 24.1902 8.07437V5.09916H21.215V3.61156C21.215 1.9684 19.883 0.636353 18.2398 0.636353H15.2646ZM15.2646 5.09916C15.2646 4.27758 15.9306 3.61156 16.7522 3.61156C17.5738 3.61156 18.2398 4.27758 18.2398 5.09916C18.2398 5.92074 17.5738 6.58677 16.7522 6.58677C15.9306 6.58677 15.2646 5.92074 15.2646 5.09916Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.36377 6.58677H7.82658V8.07437C7.82658 9.71753 9.15862 11.0496 10.8018 11.0496H22.7026C24.3458 11.0496 25.6778 9.71753 25.6778 8.07437V6.58677H30.1406V33.3636H3.36377V6.58677ZM8.81832 12.9091H13.7986V17.8893H8.81832V12.9091ZM14.51 12.9091H19.4903V17.8893H14.51V12.9091ZM25.182 12.9091H20.2017V17.8893H25.182V12.9091ZM8.81832 18.6008H13.7986V23.581H8.81832V18.6008ZM19.4903 18.6008H14.51V23.581H19.4903V18.6008ZM20.2017 18.6008H25.182V23.581H20.2017V18.6008ZM13.7986 24.2925H8.81832V29.2727H13.7986V24.2925ZM14.51 24.2925H19.4903V29.2727H14.51V24.2925ZM25.182 24.2925H20.2017V29.2727H25.182V24.2925Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_805_1940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.7273,
    height: 32.7273,
    fill: "white",
    transform: "translate(0.636475 0.636353)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperimentReport);
export default __webpack_public_path__ + "static/media/ExperimentReport.a4c2b8d1abce59c13fd4e322ecf64e65.svg";
export { ForwardRef as ReactComponent };